<ng-container *appTranslate="let t">
  <p-confirmdialog
    id="globalConfirmDialog"
    [acceptAriaLabel]="t('common.ok')"
    [closeAriaLabel]="t('common.close')"
    [rejectAriaLabel]="t('common.close')"
    [attr.ariaLabel]="'confirm-dialog-title'"
  >
    <ng-template #headless let-data let-onAccept="onAccept" let-onReject="onReject">
      <div class="p-dialog-header">
        <div class="p-dialog-title">
          {{ data.header ?? t("common.confirm") }}
        </div>
      </div>

      <div class="p-dialog-content">
        <i [class]="'p-confirmdialog-icon ' + (data.icon ?? 'pi pi-exclamation-triangle')"></i>

        <span class="p-confirmdialog-message">
          {{ data.message }}
        </span>
      </div>

      <div class="p-dialog-footer">
        @if (data.acceptVisible !== false) {
          @if (data.acceptButtonProps?.severity === "danger") {
            <new-ui-button
              [label]="data.acceptLabel ?? t('common.remove')"
              [ariaLabel]="data.acceptLabel ?? t('common.remove')"
              [icon]="data.acceptIcon ?? 'pi pi-trash'"
              variant="outlined"
              severity="danger"
              (onClick)="onAccept()"
              data-testid="btn-accept"
            />
          } @else {
            <new-ui-button
              [label]="data.acceptLabel ?? t('common.ok')"
              [ariaLabel]="data.acceptLabel ?? t('common.ok')"
              [icon]="data.acceptIcon ?? 'icon-[mi--checkmark]'"
              variant="outlined"
              severity="success"
              (onClick)="onAccept()"
              data-testid="btn-accept"
            />
          }
        }

        @if (data.rejectVisible !== false) {
          <new-ui-button
            [label]="data.rejectLabel ?? t('common.cancel')"
            [ariaLabel]="data.rejectLabel ?? t('common.cancel')"
            [icon]="data.rejectIcon ?? 'pi pi-times'"
            variant="outlined"
            severity="secondary"
            (onClick)="onReject()"
            data-testid="btn-reject"
          />
        }
      </div>
    </ng-template>
  </p-confirmdialog>
</ng-container>
